import { accordionAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
	createMultiStyleConfigHelpers(accordionAnatomy.keys);

const primaryAccent = definePartsStyle({
	container: {
		bg: "primary-accent.500",
		borderColor: "primary.500",
		rounded: "xl",
		boxShadow: "lg",
		borderWidth: 4,
	},
	button: {
		fontFamily: "heading",
		width: "full",
		fontWeight: "bold",
		fontSize: "lg",
		p: 4,
	},
	icon: {
		ml: "auto",
	},
});

export const Accordion = defineMultiStyleConfig({
	variants: { "primary-accent": primaryAccent },
});
